import { Component, OnInit } from '@angular/core';
import { WorkService } from '../services/work.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-workreport',
  templateUrl: './workreport.component.html',
  styleUrls: ['./workreport.component.less']
})
export class WorkreportComponent implements OnInit {

  isCollapsed = false;
  total:number;
  pageIndex: number;
  perPage = 10;
  page = 1;
  dataCalendar:any = [];

  constructor(
    private workService: WorkService,
    private message: NzMessageService
  ) { }

  getCalendar(){
    this.pageIndex = 1;
    this.workService.getReport(this.perPage, this.page).subscribe((res)=>{
      this.dataCalendar = res.data.docs;
      this.total = res.data.total;
    })
  }

  handleDelete(id:string): void {
    this.workService.deleteReport(id).subscribe(
      res => {
        this.message.success('Đã xóa gửi báo cáo thành công!')
        this.getCalendar();
      },
      err => {
        this.message.error('Không thể xóa báo cáo, vui lòng thử lại!')
      }

    )
  }

  onPageIndexChange($event) {
    this.workService.getReport(this.perPage, $event).subscribe((res:any)=>{
      this.dataCalendar = res.data.docs;
    })
    
  }

  ngOnInit() {
    this.getCalendar();
  } 

}
